const userDataFormValidationES = {
    "firstName": {
        "required": "El nombre es obligatorio"
    },
    "lastName": {
        "required": "El apellido es obligatorio"
    },
    "personalStreet": {
        "required": "La calle y el número son obligatorios"
    },
    "personalZip": {
        "required": "El código postal es obligatorio"
    },
    "personalCity": {
        "required": "La ciudad es obligatoria"
    },
    "personalCountry": {
        "required": "El país es obligatorio"
    },
    "businessType": {
        "required": "El tipo de negocio es obligatorio"
    },
    "companyName": {
        "required": "El nombre de la empresa es obligatorio"
    },
    "ceoFirstName": {
        "required": "El nombre del CEO es obligatorio"
    },
    "ceoLastName": {
        "required": "El apellido del CEO es obligatorio"
    },
    "businessStreet": {
        "required": "La calle y el número son obligatorios"
    },
    "businessZip": {
        "required": "El código postal es obligatorio"
    },
    "businessCity": {
        "required": "La ciudad es obligatoria"
    },
    "businessCountry": {
        "required": "El país es obligatorio"
    },
    "tradeRegistryExport": {
        "file": "Por favor, sube un archivo PDF válido (tamaño máximo 5 MB)."
    },
    "tradeRegistryExportURL": {
        "required": "La exportación del registro comercial es obligatoria"
    },
    "tradeRegistryCompanyUrl": {
        "required": "La URL del registro comercial de la empresa es obligatoria"
    }
};

export default userDataFormValidationES;